import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './ControllerEnergy.css';

const ControllerEnergy = () => {
    const [controllerData, setControllerData] = useState([]);
    const [controllerBrand, setControllerBrand] = useState('');
    const [controllerDescription, setControllerDescription] = useState('');
    const [controllerAmperes, setControllerAmperes] = useState('');
    const [controllerVoltage, setControllerVoltage] = useState('');
    const [controllerPrice, setControllerPrice] = useState('');
    const navigate = useNavigate();

    const handleAddController = async (e) => {
        e.preventDefault();

        if (controllerBrand && controllerDescription && controllerAmperes && controllerVoltage && controllerPrice) {
            const newController = {
                Brand: controllerBrand,
                Description: controllerDescription,
                Amperes: Number(controllerAmperes),
                Voltage: Number(controllerVoltage),
                Price: parseFloat(controllerPrice),
            };

            try {
                await addDoc(collection(db, 'Controladores'), newController);
                setControllerData([...controllerData, newController]);
                Swal.fire({
                    title: 'Éxito',
                    text: 'Controlador registrado con éxito.',
                });
                setControllerBrand('');
                setControllerDescription('');
                setControllerAmperes('');
                setControllerVoltage('');
                setControllerPrice('');
                navigate('/admin/controladores/settings');
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al registrar el controlador.',
                });
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Todos los campos son obligatorios.',
            });
        }
    };

    return (
        <div className="c-container">
            <h1 className="c-title">Registrar Controlador</h1>
            <form className="form-c" onSubmit={handleAddController}>
                <label className="label-c">
                    Marca
                    <input
                        className="input-c"
                        type="text"
                        value={controllerBrand}
                        onChange={(e) => setControllerBrand(e.target.value)}
                        required
                    />
                </label>
                <label className="label-c">
                    Descripción
                    <textarea
                        className="textarea-c"
                        value={controllerDescription}
                        onChange={(e) => setControllerDescription(e.target.value)}
                        required
                    />
                </label>
                <div className="input-row-c">
                    <label className="label-c">
                        Amperes
                        <input
                            className="input-c"
                            type="number"
                            value={controllerAmperes}
                            onChange={(e) => setControllerAmperes(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-c">
                        Voltaje
                        <input
                            className="input-c"
                            type="number"
                            value={controllerVoltage}
                            onChange={(e) => setControllerVoltage(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-c">
                        Precio
                        <input
                            className="input-c"
                            type="number"
                            value={controllerPrice}
                            onChange={(e) => setControllerPrice(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="c-btn-container">
                    <button className="btn-c" type="submit">Agregar controlador</button>
                    <button className="btn-c" onClick={() => navigate('/admin')}>Cancelar</button>
                </div>
            </form>
        </div>
    );
};

export default ControllerEnergy;